var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courses-container"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","min-height":"500px","border":"none"},attrs:{"src":_vm.notionEmbedUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }